import React, { Component } from "react";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import { Container, Row, Col, Breadcrumb } from "react-bootstrap";
import bannerImage from "../../Images/Banner/honarable-banner.webp";
import officialRegistar from "../../Images/Hon'ble Persons/Dr. B.P. Bhol.webp"

const AboutUs = () => {
    return (
        <>
            <title>Official Registrar- ISBM University | Academic Administration</title>
            <meta
                name="description"
                content="Explore the role of the Official Registrar at ISBM University, ensuring seamless academic administration, student records, and institutional compliance."
            />
            <Topnav />
            <section
                className="section-hero-banner ptb-50"
                style={{
                    backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
                }}
            >
                <div className="banner-hero-overlay">
                    <div className="conatiner-xxl">
                        <div className="section-hero-content">
                            <h1>From Registrar's Desk</h1>
                            <ol className="breadcrumb mt-3 text-center mb-0">
                                <li className="breadcrumb-item">
                                    <a href="/" style={{ color: "#fff", textDecoration: "none" }}>
                                        Home
                                    </a>
                                </li>
                                <li
                                    className="breadcrumb-item active text-white"
                                    aria-current="page"
                                >
                                    Hon'ble Registrar
                                </li>
                                <hr className="section-divider" />
                            </ol>
                        </div>
                    </div>
                </div>
            </section>

            <section className="vc-section ptb-50">
                <div className="container-xxl">
                    <div className="vc-container">
                        <div className="vc-image-container">
                            <div className="vc-image-wrapper shadow-sm">
                                <img src={officialRegistar} alt="Prof. (Dr.) Anand Mahalwar" className="vc-image" />
                                <div className="vc-image-overlay"></div>
                            </div>
                            <div className="vc-title-box">
                                <span className="vc-designation">Hon'ble Registrar</span>
                                <h2 className="vc-name">Dr. B.P. Bhol</h2>
                            </div>
                        </div>

                        <div className="vc-content">
                            <div className="vc-message">
                                <p className="vc-intro">
                                    On behalf of the Administration, faculty, and staff of ISBM University. I am pleased to extend a warm welcome to all of you.
                                </p>
                                <p>
                                    Education is a powerful tool that can break down the barriers to development, and higher education equips individuals with the ability to make better choices, gain access to economic stability, and achieve financial security. Our university is dedicated to providing quality education through the use of the latest technology and high academic standards. We have an excellent team of highly qualified, committed, and friendly staff members who are here to support our students and provide them with the best education possible. Our faculty members are also committed to advising and working with students to help them achieve their academic and professional goals. At ISBM University, we are committed to providing our students with improved career opportunities and greater socio-cultural awareness through our comprehensive curricular, co-curricular, and extra-curricular activities.
                                </p>
                                <div className="vc-highlight-box fw-semibold">
                                    <p>
                                        Our ultimate aim is to support our students and professionals in achieving success in their personal and professional lives, this results in increased career prospects and earning potential. Further to enhance our student's career we offer internships that provide practical opportunities for skill acquisition and career development.
                                    </p>
                                </div>

                                <p>
                                    The University provides affordable courses so that it will benefit most of the students and professionals across the world. ISBM University also welcomes world reputed universities and academic institutions for academic partnership and educational exchange programmes and recognitions.
                                </p>

                                <blockquote className="vc-quote">
                                    I take this opportunity to invite the aspirants to the University for a better learning experience.
                                </blockquote>

                                <p className="p-0">
                                    At ISBM University, we strive to empower our students with the knowledge, skills, and confidence to achieve their full potential and succeed in their personal and professional lives. We hope that your experience at ISBM University will be both rewarding and fulfilling, and that it will leave a lasting impression on your mind.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
};

export default AboutUs;
